<template>
  <div class="sm:w-9 md:w-8 lg:w-8">
    <div v-if="item.show_title && item?.name" :class="`${getTextClass(web_content_type)}`">
      {{ item.name }}
    </div>
    <div v-if="item?.body" class="text-sm text-800" v-html="item.body"></div>
    <Links v-if="item?.web_links && item.web_links.length" :web_links="item.web_links" />
  </div>
</template>
<script setup>
const props = defineProps({
  item: Object,
  web_content_type: Object,
})
import { getTextClass } from '~/composables/useUtils'
</script>
